/*global Modernizr, Splide, ThemeSlideCurrentSlide, ThemeSlideHideArrows, ThemeSlideDisableDrag */
/*jslint browser:true */

(function() {
    'use strict';

    var gallery_dialog_sliders = [];

    var gallery_dialogs = document.querySelectorAll('.gallery-dialog');
    if(gallery_dialogs) {
      gallery_dialogs.forEach((gallery_dialog) => {
        gallery_dialog.addEventListener('dialog-open', (e) => {
          var trigger = e.detail.trigger;

          if(trigger.hasAttribute('data-index')) {
            setTimeout(function() {
              gallery_dialog_sliders[trigger.getAttribute('data-open-dialog')].go(parseInt(trigger.getAttribute('data-index')));
            }, 30);
          }
        });
      });
    }

    var gallery_sm_sliders = document.querySelectorAll('.gallery-slider-sm');
    gallery_sm_sliders.forEach((gallery_slider) => {
      const slider = new Splide(gallery_slider, {
        pagination: false,
        fixedWidth: 400,
        gap: 10,
        breakpoints: {
          1030:{
            fixedWidth: 250
          }
        }
      });

      slider.on('mounted', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.classList.add('page-less');
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.classList.remove('page-less');
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.mount({ ThemeSlideHideArrows, ThemeSlideDisableDrag });
    });

    var gallery_lg_sliders = document.querySelectorAll('.gallery-slider-lg');
    gallery_lg_sliders.forEach((gallery_slider) => {
      var slider_thumbs_container = document.querySelector('#' + gallery_slider.getAttribute('data-dialog') + ' .gallery-thumbs'),
          slider_thumbs_triggers = slider_thumbs_container.querySelectorAll('.gallery-thumb-trigger');

      const slider = new Splide(gallery_slider, {
        pagination: false
      });

      slider.on('mounted', () => {
        if(slider.length <= slider.options.perPage) {
          slider.root.classList.add('page-less');
          slider.root.querySelector('.splide__arrows').classList.add('page-less');
        } else {
          slider.root.classList.remove('page-less');
          slider.root.querySelector('.splide__arrows').classList.remove('page-less');
        }
      });

      slider.on('move', (newIndex, prevIndex, destIndex) => {
        var slider_thumbs = slider_thumbs_container.querySelectorAll('li'),
            new_thumb = slider_thumbs[newIndex],
            prev_thumb = slider_thumbs[prevIndex];

        prev_thumb.classList.remove('current');
        new_thumb.classList.add('current');
      });

      slider.mount({ ThemeSlideCurrentSlide, ThemeSlideHideArrows, ThemeSlideDisableDrag });

      gallery_dialog_sliders[gallery_slider.getAttribute('data-dialog')] = slider;

      slider_thumbs_triggers.forEach((thumb_trigger) => {
        thumb_trigger.addEventListener('click', (e) => {
          slider.go(parseInt(thumb_trigger.getAttribute('data-index')));
        });
      });
    });
}());
